import { useContext } from 'react';
import GoogleOneTapContext, {
  GoogleOneTapContextType,
} from '../contexts/GoogleOneTapContext';

const useGoogleOneTap = (): GoogleOneTapContextType => {
  const context = useContext(GoogleOneTapContext);
  if (!context)
    throw new Error('useGoogleOneTap must be used within GoogleOneTapProvider');

  return context;
};

export default useGoogleOneTap;
